<div class="flex items-center justify-center px-4 py-2 gap-2 bg-[#FDF1F0]">
  <mat-icon color="warn" class="material-icons-outlined icon-action !cursor-default">report_problem</mat-icon>
  <p class="text-[#CA3434]">The subscription has expired. Please contact your Administrator to reactivate it.</p>
</div>
